<script setup lang="ts">
import { Form } from 'vee-validate'
import { formForgotPasswordSchema } from '~/validate/forms/auth'
import { AUTH_CRITERIA } from '~/validate/constant/auth'
import { useLogin } from '~/composables/account/use-login'
import { useCommon } from '~/composables/common/use-common'
import { useResetPassword } from '~/composables/account/use-reset-password'
import BaseButton from '~/components/common/base-button.vue'
import EmailIcon from '~/assets/images/pages/auth/email.png'
import BaseInput from '~/components/common/base-input.vue'

const { email, messageError, handleSubmitForgotPassword, resetError, clearInput } = useResetPassword()

const { showModalLogin } = useLogin()
const { openLiveChat } = useCommon()
</script>
<template>
  <Form
    v-slot="{ isSubmitting, meta: { valid } }"
    class="form"
    name="form-forgot-password"
    :validationSchema="formForgotPasswordSchema"
    @submit="handleSubmitForgotPassword"
  >
    <div class="form__btn-login mt-0 mb-0">
      <div class="login-now" @click="showModalLogin()"><span class="icon-arrow-left"></span></div>
      <div>
        <div class="form__title">Quên mật khẩu?</div>
        <div class="form__sub-title">Vui lòng nhập Email đã đăng ký để đặt lại mật khẩu</div>
      </div>
    </div>
    <div class="form__content">
      <BaseInput
        v-model="email"
        type="email"
        name="email"
        placeholder="Nhập địa chỉ email đăng ký"
        label="Email"
        className="required"
        :maxLength="AUTH_CRITERIA.EMAIL_MAX_LENGTH"
        :errorCustom="messageError"
        :isLabelFloating="true"
        :iconPrepend="EmailIcon"
        @input="resetError"
        @onClearInput="clearInput"
      />
    </div>

    <div class="form__btn-login mb-0">
      <BaseButton
        type="submit"
        size="extra-large"
        class="btn-submit"
        :isLoadingButton="isSubmitting"
        :disable="isSubmitting || !valid"
      >
        Gửi email
      </BaseButton>
    </div>
    <div class="form__help" @click="openLiveChat">
      <span class="live-chat"></span>
      <span>Live Chat</span>
    </div>
  </Form>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/auth/form-auth.scss';
</style>
